/**
 * @fileoverview Description, logo, activity, and size fields for registration identity.
 * @module components/AppointmentRegistrationSections/CorporateIdentity/CorporateIdentityProfileFields
 */
import { getSelectedOptionWithZeroFirst } from "../../../utils/common";
import RegistrationSelectField from "../shared/RegistrationSelectField.jsx";
import LogoUploadField from "./LogoUploadField.jsx";
import LocalizedDescriptionField from "./LocalizedDescriptionField.jsx";

const CorporateIdentityProfileFields = ({
  company,
  styles,
  form,
  getFieldValidation,
  missingRequiredFields,
}) => {
  const {
    t,
    isMobile,
    descriptions,
    currentLanguage,
    logoFile,
    isUploading,
    isDragging,
    error,
    actividadGeneralDeLaEmpresa,
    ambitoOperaciones,
    tamanoDeLaEmpresa,
    companyGeneralActivityOptions,
    operationEnvironmentOptions,
    companySizeOptions,
    getErrorMessage,
    getFieldValidationState,
    handleDescriptionChange,
    handleFileChange,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileClick,
    handleActividadGeneralChange,
    handleAmbitoOperacionesChange,
    handleTamanoDeLaEmpresaChange,
  } = form;

  return (
    <>
      {company && Object.hasOwn(company, "descripcionDeLaEmpresa") && (
        <LocalizedDescriptionField
          descriptions={descriptions}
          currentLanguage={currentLanguage}
          onChange={handleDescriptionChange}
          getFieldValidationState={getFieldValidationState}
          getFieldValidation={getFieldValidation}
          getErrorMessage={getErrorMessage}
          missingRequiredFields={missingRequiredFields}
          t={t}
          styles={styles}
        />
      )}

      {company &&
        (Object.hasOwn(company, "logo") ||
          Object.hasOwn(company, "actividadGeneralDeLaEmpresa")) && (
          <div
            className={`${styles.inputRow} ${styles.twoInputsRow} ${styles.logoAndCompanyActivityRow}`}
          >
            {company && Object.hasOwn(company, "logo") && (
              <LogoUploadField
                logoFile={logoFile}
                isUploading={isUploading}
                isDragging={isDragging}
                error={error}
                getFieldValidation={getFieldValidation}
                missingRequiredFields={missingRequiredFields}
                isMobile={isMobile}
                onFileChange={handleFileChange}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={handleFileClick}
                t={t}
                styles={styles}
              />
            )}
            {company &&
              Object.hasOwn(company, "actividadGeneralDeLaEmpresa") && (
                <RegistrationSelectField
                  fieldKey="actividadGeneralDeLaEmpresa"
                  label={t(
                    "components.corporateIdentity.companyGeneralActivityLabel",
                  )}
                  placeholder={t(
                    "components.corporateIdentity.companyGeneralActivityPlaceholder",
                  )}
                  options={companyGeneralActivityOptions}
                  value={actividadGeneralDeLaEmpresa}
                  onChange={handleActividadGeneralChange}
                  getFieldValidation={getFieldValidation}
                  missingRequiredFields={missingRequiredFields}
                  getSelectedOptionFn={getSelectedOptionWithZeroFirst}
                  inputGroupClassName={`${styles.inputGroup} ${styles.logoAndCompanyActivityContainer}`}
                  styles={styles}
                />
              )}
          </div>
        )}

      {company &&
        (Object.hasOwn(company, "ambitoOperaciones") ||
          Object.hasOwn(company, "tamanoDeLaEmpresa")) && (
          <div className={`${styles.inputRow} ${styles.twoInputsRow}`}>
            {company && Object.hasOwn(company, "ambitoOperaciones") && (
              <RegistrationSelectField
                fieldKey="ambitoOperaciones"
                label={t(
                  "components.corporateIdentity.operationEnvironmentLabel",
                )}
                placeholder={t(
                  "components.corporateIdentity.operationEnvironmentPlaceholder",
                )}
                options={operationEnvironmentOptions}
                value={ambitoOperaciones}
                onChange={handleAmbitoOperacionesChange}
                getFieldValidation={getFieldValidation}
                missingRequiredFields={missingRequiredFields}
                styles={styles}
              />
            )}
            {company && Object.hasOwn(company, "tamanoDeLaEmpresa") && (
              <RegistrationSelectField
                fieldKey="tamanoDeLaEmpresa"
                label={t("components.corporateIdentity.companySizeLabel")}
                placeholder={t(
                  "components.corporateIdentity.companySizePlaceholder",
                )}
                options={companySizeOptions}
                value={tamanoDeLaEmpresa}
                onChange={handleTamanoDeLaEmpresaChange}
                getFieldValidation={getFieldValidation}
                missingRequiredFields={missingRequiredFields}
                styles={styles}
              />
            )}
          </div>
        )}
    </>
  );
};

export default CorporateIdentityProfileFields;
